import React from 'react'
import Footer from '../../../general/footer/Footer';

import client2 from '../../../assets/client2.jpg'
import img2 from "../../../assets/img2.jpg";
import lsimg1 from "../../../assets/lsimg1.jpg"
import { Link } from 'react-router-dom';

const Loan = () => {
    return (
        <div>
            <div className="insurance-section">
                <div className="insurance-content">
                    <div className="breadcrumb">
                        <span>Home</span> &nbsp;•&nbsp;
                        <span>Our Services</span> &nbsp;•&nbsp;
                        <span className="active">Loan Syndication</span>
                    </div>
                    <h1>Loan Syndication</h1>
                    <p>
                        At PSJ Capital Ventures, we serve as your syndication partner, connecting your funding needs with the right lending institutions and structuring deals that are efficient, transparent, and growth-oriented.
                    </p>
                </div>
                <div className="insurance-image">
                    <img src={lsimg1} alt="Insurance Family" />
                </div>
            </div>

            <div className="travel-details-container">
                {/* LEFT SECTION */}
                <div className="travel-details-left">
                    <h2>What Is Loan Syndication?</h2>
                    <p>
                        Loan syndication is the process of arranging funding for a borrower from multiple lenders, rather than relying on a single financial institution. It is commonly used when the loan amount is too large or complex for one lender to handle alone. This approach allows businesses to access higher funding limits and benefit from customized financial structuring.
                    </p>

                    <h3 style={{ color: 'black' }}>Why Loan Syndication Matters</h3>

                    <h5>	•Access to Larger Capital</h5>
                    <p className="bold-line">
                        Syndicated loans allow businesses to raise higher amounts of funding than what individual lenders usually offer.
                    </p>

                    <h5>•	Better Terms and Flexibility</h5>
                    <p className="bold-line">
                        Multiple lenders competing for a piece of the deal often results in better interest rates, repayment structures, and more borrower-friendly terms.
                    </p>

                    <h5>•	Risk Distribution</h5>
                    <p className="bold-line">
                        Credit risk is distributed among all participating lenders, making it more acceptable to each one and enhancing your chances of approval.
                    </p>

                    <h5>	•	Improved Credibility and Visibility</h5>
                    <p className="bold-line">
                        Successfully managing a syndicated loan builds reputation in the financial ecosystem and can improve future access to funding.
                    </p>


                    <h3 style={{ color: 'black' }}>The PSJ Advantage</h3>
                    <div className="plan-columns">

                        <div>
                            <h5>1. 		End-to-End Support</h5>
                            <p>We handle everything—from evaluating your needs to securing funding and closing the deal.
                            </p>
                            <h5>2. 		Strong Lender Network </h5>
                            <p>Our partnerships span across top banks, NBFCs, and alternative funding institutions.</p>
                        </div>
                        <div>
                            <h5>3. 		Custom Structuring </h5>
                            <p>Every business is unique. We tailor terms, repayment schedules, and structures to fit your business model.</p>
                            <h5>4. 		Speed and Transparency </h5>
                            <p>We guarantee fast execution with no unexpected delays, allowing you to concentrate on growth instead of paperwork.</p>
                        </div>
                    </div>

                    {/* Service Benefits */}
                    <div className="benefits-section">
                        <div className="benefits-image">
                            <img src={img2} alt="Service Benefits" />
                        </div>
                        <div className="benefits-list">
                            <h4>Our Syndication Process</h4>
                            {/* <p>
                                We help you invest across a wide spectrum of mutual fund categories:
                            </p> */}
                            <ul>
                                <li>✓ 	•		Requirement Assessment  </li>
                                <li>✓ 	•		Credit Profiling and Proposal Development </li>
                                <li>✓ 	•		Lender Identification  </li>
                                <li> ✓	•		Negotiation and Documentation  </li>
                                <li> ✓  •		Deal Execution and Monitoring  </li>
                            </ul>
                        </div>
                    </div>


                    {/* More Benefits */}
                    <div className="service-benefits">
                        <h3>Who Can Benefit from Loan Syndication?</h3>

                        <ul>
                            <li>✓ 		Businesses looking to expand operations or invest in large-scale projects</li>
                            <li>✓ 		Real estate and infrastructure developers</li>
                            <li>✓ 		Companies with high capital expenditure or seasonal revenue</li>
                            <li>✓ 		Organizations seeking to refinance existing loans on better terms</li>
                            <li>✓ 		Firms requiring structured project or working capital finance</li>
                        </ul>
                        <p>
                            Let’s Structure Your Next Big Loan
                            Book a consultation to discuss your financing needs. At PSJ Capital Ventures, we turn capital challenges into growth-ready solutions.

                        </p>
                    </div>
                    <Link to='/contact'><button className="get-touch-btn">Get in Touch →</button></Link>
                </div>

                {/* RIGHT SECTION */}
                <div className="travel-details-right">
                    <div className="services-box">
                        <h4>Our Services</h4>
                        <ul>
                            <Link to='/mutual-funds'><li>Mutual Funds →</li></Link>
                            <Link to='/portfolio-management-services'><li>Portfolio Management Services →</li></Link>
                            <Link to='/macro-treasury-research'><li>Macro/Treasury Research →</li></Link>
                            <Link to='/nri-corner'><li>NRI Corner →</li></Link>
                            <Link to='/family-offices'><li>Family Offices →</li></Link>
                            <Link to='/insurance'><li>Insurance →</li></Link>
                            <Link to='/alternative-investment-funds'><li>Alternative Investment Funds →</li></Link>
                            <Link to='/sme-ipo-advisory'><li>SME IPO Advisory →</li></Link>
                            <Link to='/fundraising-assistance'><li>Fundraising Assistance →</li></Link>
                            <Link to='/stock-broking'><li>Stock Broking →</li></Link>
                        </ul>
                    </div>

                    <div className="advisor-box">
                        <img src={client2} alt="Advisor" />
                        <p>Make your dream life get professional help</p>
                        <div className="contact-info">
                            <span>📞 CONTACT US</span>
                            <p>+91 8108 430 942</p>
                        </div>
                    </div>
                </div>
            </div>
            <br></br><br></br><br></br>
            <Footer />
        </div>
    )
}

export default Loan;